package com.heelion.farmafreelance.utils

import com.heelion.farmafreelance.models.*
import kotlinx.datetime.*

object ReputationUtils {
    private const val MIN_DATA_THRESHOLD = 5
    private const val DISCOUNT_THRESHOLD = 15

    fun calculateReputation(
        matches: List<Match>,
        historicalCompleted: Int = 0,
        historicalCancelled: Int = 0
    ): UserReputation {
        val relevantMatches = matches.filter { 
            it.stato == MatchStato.COMPLETATO || 
            it.stato == MatchStato.ANNULLATO || 
            it.stato == MatchStato.CONFERMATO 
        }

        val completed = relevantMatches.count { it.stato == MatchStato.COMPLETATO } + historicalCompleted
        val cancelled = relevantMatches.count { it.stato == MatchStato.ANNULLATO } + historicalCancelled
        val confirmed = relevantMatches.count { it.stato == MatchStato.CONFERMATO }
        
        val totalDecided = completed + cancelled
        
        val hasEnoughData = (relevantMatches.size + historicalCompleted + historicalCancelled) >= MIN_DATA_THRESHOLD
        
        val stars = if (totalDecided > 0) {
            (completed.toDouble() / totalDecided.toDouble()) * 5.0
        } else if (hasEnoughData) {
            5.0 // Se ha molti confermati ma nessuno ancora "finito", partiamo bene
        } else {
            0.0
        }

        // Calcolo per lo sconto (basato sul mese corrente)
        val now = Clock.System.now().toLocalDateTime(TimeZone.currentSystemDefault())
        val completedThisMonth = relevantMatches.count { match ->
            match.stato == MatchStato.COMPLETATO && match.createdAt?.let {
                val ldt = it.toLocalDateTime(TimeZone.currentSystemDefault())
                ldt.month == now.month && ldt.year == now.year
            } ?: false
        }

        val discountEligible = completedThisMonth >= DISCOUNT_THRESHOLD && stars >= 4.0
        val nextDiscountProgress = if (completedThisMonth < DISCOUNT_THRESHOLD) {
            DISCOUNT_THRESHOLD - completedThisMonth
        } else {
            0
        }

        return UserReputation(
            completedCount = completed,
            cancelledCount = cancelled,
            confirmedCount = confirmed,
            stars = stars,
            discountEligible = discountEligible,
            nextDiscountProgress = nextDiscountProgress,
            hasEnoughData = hasEnoughData
        )
    }
}
